//*******************************************************************************************
//* WaMS Component Framework - app.input.js
//* Version 0.1
//* Author: Damian Koch
//* Component framework input helpers plugin
//* Requires jQuery, WaMS Component Framework
//* 
//* This component adds some rich input features.  When this file is loaded, certain
//* fields/attributes will be looked for in forms on showEditMode complete.
//* 
//* 10/17/18    DBK      Created!
//* 02/14/18    DBK      [STUDYAB-650]: Added support for content template helpers
//* 02/15/18    Kraus    [STUDYAB-655]: Added select many support
//* 02/21/18    Koch     [STUDYAB-667]: updates to select many
//* 03/15/18    Huisenga [STUDYAB-361]: swaped to froala
//* 03/21/18    Koch     [STUDYAB-690]: encapsulated studyab updates a bit more, add city support
//* 04/10/18    Huisenga [STUDYAB-747]: Updated to run init on page if not in edit component
//* 04/16/18    Peck     [STUDYAB-729]: Updated select many logic to allow dropdown filters
//* 06/11/18    Peck     [STUDYAB-875]: Updated select many dropdown logic
//* 10/12/18    Kraus    [STUDYAB-195]: Added block_text options explicitly to TinyMCE
//*******************************************************************************************

app.input = (function () {
    var myInput = {
        Init: function () {
            this.initInputComponents(document);
            //init page

            //init future components
            $(document).on('component-bind-edit-mode-complete', function (e, component) {
                component.page.log('component-bind-edit-mode-complete triggered: ' + component.type);
                app.input.initInputComponents(component.editComponent);
            });
        },
        initInputComponents: function (el) {
            app.input.initMasks(el);
            app.input.initComponentTemplate(el);
            app.input.initCitySelect(el);
            app.input.initTextEditor(el);
            app.input.initDatePicker(el);
            app.input.initSelectMany(el);
            app.input.initTextAreas(el);
            if ($("#divActivityLog").length > 0) {
                app.ActivityLog.Init();
            }
            //app.input.initAutocomplete(el);
        },
        initMasks: function (editComponent) {
            $('[data-component-input-type="Phone"]', editComponent).mask('(000)000-0000');
            $('[data-component-input-type="date"]', editComponent).mask('00/00/0000');
            $('[data-component-input-type="numeric"]', editComponent).mask('000000000000.00', { reverse: true });
            $('[data-component-input-type="currency"]', editComponent).mask('#,##0.00', { reverse: true });
        },
        initTextAreas: function (editComponent) {
            $('textarea').each(function () {
                this.setAttribute('style', 'height:' + (this.scrollHeight) + 'px;overflow-y:hidden;');
            }).on('input', function () {
                this.style.height = 'auto';
                this.style.height = (this.scrollHeight) + 'px';
            });
        },
        initComponentTemplate: function (editComponent) {
            $('[data-role="content-template-select"]', editComponent).on('change', function (e) {
                var sel = $(e.target);
                var target = $('#' + sel.data('content-template-target'));
                if (target.data('role') === 'richtext') {
                    $(tinymce.get(sel.data('content-template-target')).getBody()).html(sel.val());
                    tinymce.triggerSave();
                } else {
                    target.val(sel.val());
                }
            });
        },
        initCitySelect: function (editComponent) {
            var that = this;
            $('[data-role="country-select"]', editComponent).on('change', function (e) {
                that.filterCities(e.target, editComponent);
            });
            $('[data-role="country-select"]', editComponent).each(function (i, e) { that.filterCities(e, editComponent); });
        },
        filterCities: function (e, editComponent) {
            var guid = $(e).data('role-guid');
            var cityddl = $('[data-role="city-select"][data-role-guid="' + guid + '"]', editComponent);
            var countryVal = $(e).val();

            if (countryVal === '') {
                cityddl.children('option').show();
            } else {
                if ($('option:selected', cityddl).attr('country') !== countryVal) {
                    cityddl.val('');
                }
                cityddl.children('option[country]').hide();
                cityddl.children('option[country="' + countryVal + '"]').show();
            }

            app.page.log('country selected:' + countryVal);
        },
        initSelectMany: function (editComponent) {
            $('[data-role="select-many"]', editComponent).each(function () {
                var selectManyContext = this;
                var listSelected = function (el) {
                    var selectedCheckboxNames;
                    var context = $(el).closest('[data-role="select-many"]');
                    var fieldSet = $('fieldset', context);

                    if ($('[type="checkbox"]:not(:checked)', fieldSet).length === 0) {
                        selectedCheckboxNames = "All";
                    }
                    else {
                        if ($('[type="checkbox"]:checked', fieldSet).length === 0) {
                            selectedCheckboxNames = "None";
                        } else {
                            selectedCheckboxNames = $('[type="checkbox"]:checked + label', fieldSet).map(function () {
                                return this.innerText;
                            }).get().join(', ');
                        }
                    }

                    $('[data-role="selected-item-list"]', context).text(selectedCheckboxNames);
                };

                listSelected($('fieldset', this));

                //on change update selection list label
                $('input[type="checkbox"]', selectManyContext).on('change', function () { listSelected(this); });

                //filter event listener
                $(selectManyContext).on('keyup', '[data-role="select-many-filter"]', function () {
                    var value = $(this).val().toLowerCase();
                    const selMany = $(this).closest('[data-role="select-many"]');

                    var hiddenToggle = $(selectManyContext).find('[data-role="select-many-hide-toggle"]').val() === 'true';

                    selMany.find('.select-many-checkbox').each(function () {
                        if ($(this).find('label').text().toLowerCase().search(value) > -1) {
                            if (!hiddenToggle || (hiddenToggle && $(this).hasClass('select-many-checkbox-hide') !== true)) {
                                $(this).show();
                            }
                        }
                        else {
                            $(this).hide();
                        }
                    });

                    var selAll = selMany.find('[type="checkbox"][data-role~="selectall"]:visible');
                    var selAllChecked = true;


                    //loop through visible values, if any is false, then mark the box as not all selected
                    selMany.find('.select-many-checkbox input[type="checkbox"]:visible').each(function (ind, el) {
                        if ($(el).prop('checked') !== true) {
                            selAllChecked = false;
                            // returning false breaks from loop
                            return false;
                        }
                    });

                    selAll.prop('checked', selAllChecked);
                });

                // Hide toggle event listener
                $(selectManyContext).on('click', '[data-role="select-many-hide-toggle"]', function () {
                    var value = $(this).val().toLowerCase();
                    var displayText = $(this).data("display-text");
                    const selMany = $(this).closest('[data-role="select-many"]');

                    if (value === 'false') {  // Currently visible, so we hide
                        $(this).val('true');
                        $(this).text('Show ' + displayText);
                        selMany.find('.select-many-checkbox-hide').each(function () {
                            $(this).hide();
                            $(this).find("input").prop('checked', false);
                        });

                    }
                    else {  // Current hidden, so we show
                        $(this).val('false');
                        $(this).text('Hide ' + displayText);
                        selMany.find('.select-many-checkbox').each(function () {
                            $(this).show();
                        });
                    }

                    //Run the check for the Select All box after clicking the show/hide toggle
                    var selAll = selMany.find('[type="checkbox"][data-role~="selectall"]:visible');
                    var selAllChecked = true;
                    var selCount = 0;


                    //loop through visible values, if any is false, then mark the box as not all selected
                    selMany.find('.select-many-checkbox input[type="checkbox"]:visible').each(function (ind, el) {
                        if ($(el).prop('checked') !== true) {
                            selAllChecked = false;
                            // returning false breaks from loop
                            return false;
                        } else {
                            selCount++;
                        }
                    });

                    if (selCount > 0 && selAllChecked) {
                        selAll.prop('checked', true);
                    } else {
                        selAll.prop('checked', false);
                    }

                    // Select All display
                    var selectedCheckboxNames;
                    var context = $(this).closest('[data-role="select-many"]');
                    var fieldSet = $('fieldset', context);

                    if ($('[type="checkbox"]:not(:checked)', fieldSet).length === 0) {
                        selectedCheckboxNames = "All";
                    }
                    else {
                        if ($('[type="checkbox"]:checked', fieldSet).length === 0) {
                            selectedCheckboxNames = "None";
                        } else {
                            selectedCheckboxNames = $('[type="checkbox"]:checked + label', fieldSet).map(function () {
                                return this.innerText;
                            }).get().join(', ');
                        }
                    }

                    $('[data-role="selected-item-list"]', context).text(selectedCheckboxNames);


                });

                console.log(editComponent);

                //custom dropdown filter event listener
                $(editComponent).on('change', 'select[data-role="filter-select-many"]', function () {

                    //var filterField = $(this).data("filter-field");
                    var filterTargetFieldset = $("#fst" + $(this).data("target"), selectManyContext);
                    //var selectedOption = $(this).val();

                    var allSelects = $('select[data-role="filter-select-many"][data-target="' + $(this).data("target") + '"]');

                    filterTargetFieldset.find(".select-many-checkbox").each(function () {
                        var showThis = true;
                        var curCheckbox = $(this).find("input");

                        allSelects.each(function (el) {
                            var selectedOption = $(this).val();
                            var filteredField = $(this).data("filter-field");
                            var filteredFieldValue = curCheckbox.data(filteredField);

                            showThis = showThis && (selectedOption == null || selectedOption === "" || filteredFieldValue == selectedOption);
                        });

                        if (showThis) {
                            $(this).show();
                        }
                        else {
                            $(this).hide();
                        }
                    });

                    var selAll = $('[type="checkbox"][data-role~="selectall"][name="' + $(this).data("target") + '"]:visible');
                    var selAllChecked = true;
                    $('.select-many-checkbox input[type="checkbox"][name="' + $(this).data("target") + '"]:visible').each(function (ind, el) {
                        if ($(el).prop('checked') != true) {
                            selAllChecked = false;
                            // returning false breaks from loop
                            return false;
                        }
                    });
                    
                    selAll.prop('checked', selAllChecked);
                });
            });
        },
        initDatePicker: function (editComponent) {
            $('[data-component-role="startdate"]', editComponent).fdatepicker().on('changeDate', function (ev) {
                //When start date changes, check the end date
                //Find end date
                var endDateElement = $('#' + $(this).data('enddate-target'), $(this.form)).fdatepicker();

                if (ev.date.valueOf() > new Date(endDateElement.val()).getTime()) {
                    //If the end date is too early, set to know and give focus
                    var newDate = new Date(ev.date);
                    newDate.setDate(newDate.getDate() + 1);
                    endDateElement.fdatepicker('update', newDate);
                    $(this).fdatepicker('hide');
                    endDateElement[0].focus();
                }

            }).data('datepicker');

            $('[data-component-role="enddate"]', editComponent).fdatepicker({
                onRender: function (date) {
                    //get start date
                    var startDate = $('[data-enddate-target="' + this.element.attr('id') + '"').fdatepicker();
                    //Only allow 
                    return date.valueOf() <= new Date(startDate.val()).getTime() ? 'disabled' : '';
                }
            }).on('changeDate', function (ev) {
                $(this).fdatepicker('hide');
                }).data('datepicker');


            $('[data-role~="datepicker"]', editComponent).fdatepicker();
        },
        initTextEditor: function (editComponent) {
            $('[data-role~="richtext"]', editComponent).each(function (index) {
                tinymce.remove('#' + this.id);
                tinymce.init({
                    selector: '#' + this.id, // change this value according to your HTML
                    block_formats:
                        'Paragraph=p;Heading 1=h1;Heading 2=h2;Heading 3=h3;Heading 4=h4;Heading 5=h5;Heading 6=h6;Preformatted=pre',
                    themes: "modern",
                    plugins: "code lists link textcolor table autoresize",
                    mode: "textareas",
                    autoresize_on_init: false,
                    autoresize_bottom_margin: 0,
                    autoresize_min_height: 100,
                    branding: false,
                    menubar: false,
                    forced_root_block: "",
                    toolbar: [
                        'bold italic superscript subscript | formatselect | numlist bullist | forecolor backcolor | alignleft aligncenter alignright | link | indent outdent | removeformat code'
                    ],
                    init_instance_callback: function (editor) {
                        editor.on('change', function (e) {
                            tinymce.triggerSave();
                            $('#' + e.target.id).change();
                            $('#' + e.target.id).valid();
                        });
                    }
                });

                //Hook hidden field into the validation
                //Tried setting this on the form on creation, on custom validators.... Would not bind correctly
                //This works the best out of kludge options
                var form = $(this.form);
                if (form != undefined) {
                    //create the validator
                    $.validator.unobtrusive.parse(form);
                    //set validator options
                    var validator = form.data('validator');
                    if (validator !== undefined) {
                        validator.settings.ignore =
                            ':hidden:not([data-role~="richtext"]),.mce-content-body';
                    }
                }
            });
        },
        initAutocomplete: function (editComponent) {
            $('[data-role~="autocomplete"]', editComponent).each(function() {
                var ac = new app.Autocomplete($(this));
            });
            app.Autocomplete.BindSetButtons(editComponent);
        }
    };

    return myInput;
}());

$(function () {
    app.input.Init();
});